import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import {
  productcreate,
  productdelete,
  productdetail,
  productlist,
  productupdate,
  schoollist,
  vendorlist,
  webpageproductstatus,
} from "../../../../services/superadmin";
import Select from "react-select";
import { toast } from "react-toastify";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import Swal from "sweetalert2";
import { funderlist, grpschlist } from "../../../../services/master";
import { useNavigate } from "react-router-dom";

export const ShopProductList = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");

  const columnDefs = [
    {
      headerName: "Actions",
      width: 230,
      field: "id",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              title="Edit Product"
              className="btn-sm btn-success me-2"
              onClick={() => viewpdt(params.value)}
            >
              <i className="fa fa-edit fa-lg"></i>
            </a>
            <a
              title="School List"
              className="btn-sm btn-secondary me-2"
              onClick={() => schlist(params.value, params)}
            >
              <i className="fa fa-list fa-lg"></i>
            </a>
            <a
              title="Funder List"
              className="btn-sm btn-warning me-2"
              onClick={() => funlist(params.value, params)}
            >
              <i className="fa fa-list fa-lg"></i>
            </a>
            <a
              title="Group of School List"
              className="btn-sm btn-export me-2"
              onClick={() => grplist(params.value, params)}
            >
              <i className="fa fa-list fa-lg"></i>
            </a>
            <a
              title="Delete Product"
              className="btn-sm btn-danger"
              onClick={() => deletepdt(params)}
            >
              <i className="fa fa-trash fa-lg"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "School Webpage",
      field: "school_display",
      width: 100,
      resizable: true,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <label className="custom-switch mb-0">
              <input
                title="School Webpage"
                type="checkbox"
                name="custom-switch-checkbox"
                className="custom-switch-input"
                checked={params.value === 1 ? true : false}
                onClick={() => deactivewebpage(1, params)}
              />

              <span className="custom-switch-indicator"></span>
            </label>
          </div>
        );
      },
    },
    {
      headerName: "Funder Webpage",
      field: "funder_display",
      width: 100,
      resizable: true,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <label className="custom-switch mb-0">
              <input
                title="Funder Webpage"
                type="checkbox"
                name="custom-switch-checkbox"
                className="custom-switch-input"
                checked={params.value === 1 ? true : false}
                onClick={() => deactivewebpage(2, params)}
              />

              <span className="custom-switch-indicator"></span>
            </label>
          </div>
        );
      },
    },
    {
      headerName: "Group Webpage",
      field: "group_display",
      width: 100,
      resizable: true,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <label className="custom-switch mb-0">
              <input
                title="Group of School Webpage"
                type="checkbox"
                name="custom-switch-checkbox"
                className="custom-switch-input"
                checked={params.value === 1 ? true : false}
                onClick={() => deactivewebpage(3, params)}
              />

              <span className="custom-switch-indicator"></span>
            </label>
          </div>
        );
      },
    },
    {
      headerName: "Vendor",
      field: "vendor_name",
      width: 150,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Product ID",
      field: "product_id",
      width: 100,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Name",
      field: "product_name",
      width: 150,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Product Price",
      field: "product_price",
      width: 150,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Offer Price",
      field: "offer_price",
      width: 150,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Color",
      field: "color",
      width: 100,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Image Url",
      field: "image_url",
      width: 150,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <img src={params.value} width="50px" height="50px" />
          </div>
        );
      },
    },
    {
      headerName: "Product Url",
      field: "product_url",
      width: 150,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              className="btn-sm btn-secondary"
              href={params.value}
              target="blank"
            >
              Link
            </a>
          </div>
        );
      },
    },
  ];

  function deactivewebpage(did, ddata) {
    if (ddata.value === 1) {
      Swal.fire({
        text: "Are you sure want to Inactive the product?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ac0404",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Inactive",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          if (did == 1) {
            dotracking(
              " school webpage status icon in product list from Active to Inactive for " +
                ddata.data.product_name +
                " (" +
                ddata.data.id +
                ") $$ " +
                trackobj.pdtheading
            );
          } else if (did == 2) {
            dotracking(
              " funder webpage status icon in product list from Active to Inactive for " +
                ddata.data.product_name +
                " (" +
                ddata.data.id +
                ") $$ " +
                trackobj.pdtheading
            );
          } else if (did == 3) {
            dotracking(
              " group webpage status icon in product list from Active to Inactive for " +
                ddata.data.product_name +
                " (" +
                ddata.data.id +
                ") $$ " +
                trackobj.pdtheading
            );
          }
          webpageproductstatus(ddata.data.id, did, 0).then((response) => {
            if (response.status === true) {
              listall();
              toast.success(response.message);
            }
          });
        }
      });
    } else {
      Swal.fire({
        text: "Are you sure want to Active the product?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#008000",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Active",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          if (did == 1) {
            dotracking(
              " school webpage status icon in product list from Inactive to Active for " +
                ddata.data.product_name +
                " (" +
                ddata.data.id +
                ") $$ " +
                trackobj.pdtheading
            );
          } else if (did == 2) {
            dotracking(
              " funder webpage status icon in product list from Inactive to Active for " +
                ddata.data.product_name +
                " (" +
                ddata.data.id +
                ") $$ " +
                trackobj.pdtheading
            );
          } else if (did == 3) {
            dotracking(
              " group webpage status icon in product list from Inactive to Active for " +
                ddata.data.product_name +
                " (" +
                ddata.data.id +
                ") $$ " +
                trackobj.pdtheading
            );
          }
          webpageproductstatus(ddata.data.id, did, 1).then((response) => {
            if (response.status === true) {
              listall();
              toast.success(response.message);
            }
          });
        }
      });
    }
  }

  useEffect(() => {
    listall();
    vendorlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.vendor_list.length !== 0) {
          for (let i = 0; i < res.data.vendor_list.length; i++) {
            arr.push({
              value: res.data.vendor_list[i].id,
              label: res.data.vendor_list[i].vendor_name,
            });
          }
        }
        setVList(arr);
      }
    });
    if (localStorage.getItem("Role") === "1") {
      schoollist().then((response) => {
        if (response.status === true) {
          let arr = [{ value: 0, label: "All" }];
          if (response.data.details.length !== 0) {
            for (let i = 0; i < response.data.details.length; i++) {
              arr.push({
                value: response.data.details[i].id,
                label:
                  response.data.details[i].school_name +
                  " - " +
                  response.data.details[i].school_unique_no,
              });
            }
          }
          setSList(arr);
        }
      });

      funderlist().then((response) => {
        if (response.status === true) {
          let arr = [{ value: 0, label: "All" }];

          if (response.data.funders_list.length !== 0) {
            for (let i = 0; i < response.data.funders_list.length; i++) {
              arr.push({
                value: response.data.funders_list[i].id,
                label: response.data.funders_list[i].funder_name,
              });
            }
          }
          setFList(arr);
        }
      });

      grpschlist().then((response) => {
        if (response.status === true) {
          let arr = [{ value: 0, label: "All" }];
          if (response.data.funders_list.length !== 0) {
            for (let i = 0; i < response.data.funders_list.length; i++) {
              arr.push({
                value: response.data.funders_list[i].id,
                label: response.data.funders_list[i].group_of_school_name,
              });
            }
          }
          setGList(arr);
        }
      });
    }
  }, []);

  function listall() {
    setFilterProduct([]);
    productlist().then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data.product_list);
      }
    });
  }
  const navigate = useNavigate();
  function schlist(sid, sdata) {
    dotracking(
      "school list icon in product list for " +
        sdata.data.product_name +
        " (" +
        sdata.data.id +
        ") $$ " +
        trackobj.schpdtlistheading
    );
    navigate("/superadmin/schoolproducts/" + sid);
  }

  function funlist(sid, sdata) {
    dotracking(
      "funder list icon in product list for " +
        sdata.data.product_name +
        " (" +
        sdata.data.id +
        ") $$ " +
        trackobj.funpdtlistheading
    );
    navigate("/superadmin/funderproducts/" + sid);
  }

  function grplist(sid, sdata) {
    dotracking(
      "group of school list icon in product list for " +
        sdata.data.product_name +
        " (" +
        sdata.data.id +
        ") $$ " +
        trackobj.grppdtlistheading
    );
    navigate("/superadmin/groupproducts/" + sid);
  }

  function deletepdt(list) {
    Swal.fire({
      text: "Are you sure want to Delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete icon in product list for " +
            list.data.product_name +
            " (" +
            list.data.id +
            ") $$ " +
            trackobj.pdtheading
        );
        productdelete(localStorage.getItem("UID"), list.data.id).then(
          (response) => {
            if (response.status === true) {
              listall();
              toast.success(response.message);
            }
          }
        );
      }
    });
  }

  function viewpdt(wid) {
    productdetail(wid).then((res) => {
      if (res.status === true && res.data.product_details) {
        setPID(res.data.product_details.id);
        setPdtID(res.data.product_details.product_id);
        setPdtName(res.data.product_details.product_name);
        setPdtPrice(res.data.product_details.product_price);
        setOfrPrice(res.data.product_details.offer_price);
        setPImage(res.data.product_details.image_url);
        setPUrl(res.data.product_details.product_url);
        if(res.data.product_details.color !== null){
          setPdtClr(res.data.product_details.color);
        }
        vendorlist().then((res1) => {
          if (res1.status === true) {
            let arr = [];
            if (res1.data.vendor_list.length !== 0) {
              for (let i = 0; i < res1.data.vendor_list.length; i++) {
                if (
                  res1.data.vendor_list[i].id ===
                  res.data.product_details.vendor_id
                )
                  arr.push({
                    value: res1.data.vendor_list[i].id,
                    label: res1.data.vendor_list[i].vendor_name,
                  });
              }
            }
            setVenID(arr[0]);
          }
        });
        let arr = [];
        if (res.data.product_details.school_display == 1) {
          arr.push({ value: 1, label: "School Webpages" });
          setWSch(true);
        }
        if (res.data.product_details.funder_display == 1) {
          arr.push({ value: 2, label: "Funder Webpages" });
          setWFun(true);
        }
        if (res.data.product_details.group_display == 1) {
          arr.push({ value: 3, label: "Group of School Webpages" });
          setWGrp(true);
        }
        setWebID(arr);
        setShow(true);
      }
    });
  }

  const [show, setShow] = useState(false);
  const [pid, setPID] = useState(0);
  const [vlist, setVList] = useState([]);
  const [venid, setVenID] = useState([]);

  const [wlist, setWList] = useState([
    {
      value: 1,
      label: "School Webpages",
    },
    {
      value: 2,
      label: "Funder Webpages",
    },
    {
      value: 3,
      label: "Group of School Webpages",
    },
  ]);
  const [wsch, setWSch] = useState(false);
  const [wfun, setWFun] = useState(false);
  const [wgrp, setWGrp] = useState(false);
  const [webid, setWebID] = useState("");

  const [slist, setSList] = useState([]);
  const [flist, setFList] = useState([]);
  const [glist, setGList] = useState([]);

  const [schid, setSchID] = useState({ value: 0, label: "All" });
  const [funid, setFunID] = useState({ value: 0, label: "All" });
  const [grpid, setGrpID] = useState({ value: 0, label: "All" });

  const [ssid, setSID] = useState(0);
  const [ffid, setFID] = useState(0);
  const [ggid, setGID] = useState(0);

  const [pdtid, setPdtID] = useState("");
  const [pdtname, setPdtName] = useState("");
  const [pdtprice, setPdtPrice] = useState("");
  const [ofrprice, setOfrPrice] = useState("");
  const [pimage, setPImage] = useState("");
  const [purl, setPUrl] = useState("");
  const [pdtclr, setPdtClr] = useState("");

  function handleshow() {
    setPdtID("");
    setPID(0);
    setPdtName("");
    setPdtPrice("");
    setOfrPrice("");
    setPImage("");
    setPUrl("");
    setPdtClr("");
    setWSch(false);
    setWFun(false);
    setWGrp(false);
    setSID(0);
    setFID(0);
    setGID(0);
    setErrorMsg("");
    setShow(true);
  }

  function handleclose() {
    setShow(false);
    setErrorMsg("");
    setPdtID("");
    setPID(0);
    setPdtName("");
    setPdtPrice("");
    setOfrPrice("");
    setPImage("");
    setPUrl("");
    setPdtClr("");
    setWSch(false);
    setWFun(false);
    setWGrp(false);
    setSID(0);
    setFID(0);
    setGID(0);
  }

  function handleVendor(e) {
    if (e !== null) {
      setVenID(e);
    } else {
      setVenID("");
    }
  }

  const handlePrice = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPdtPrice(e.target.value);
    }
  };
  const handleOffer = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setOfrPrice(e.target.value);
    }
  };

  function handleWebpage(e) {
    setWSch("");
    setWFun("");
    setWGrp("");
    let schoolOptions = "";
    let funderOptions = "";
    let groupOptions = "";
    if (e !== null) {
      if (Array.isArray(e)) {
        schoolOptions = e.find((item) => item.label.includes("School"));
        funderOptions = e.find((item) => item.label.includes("Funder"));
        groupOptions = e.find((item) => item.label.includes("Group"));
      } else {
        schoolOptions = e.label.includes("School");
        funderOptions = e.label.includes("Funder");
        groupOptions = e.label.includes("Group");
      }

      setWSch(schoolOptions || false);
      setWFun(funderOptions || false);
      setWGrp(groupOptions || false);

      setWebID(e);
    } else {
      setWSch(false);
      setWFun(false);
      setWGrp(false);
    }
  }

  function handleSchool(e) {
    if (e !== null) {
      let schoolOptions = "";
      if (Array.isArray(e)) {
        schoolOptions = e.find((item) => item.label.includes("All"));
      } else {
        schoolOptions = e.label.includes("All");
      }
      if (schoolOptions) {
        setSchID({ value: 0, label: "All" });
        setSID(0);
      } else {
        setSchID(e);
        setSID(111);
      }
    } else {
      setSchID("");
      setSID(0);
    }
  }

  function handleFunder(e) {
    if (e !== null) {
      let schoolOptions = "";
      if (Array.isArray(e)) {
        schoolOptions = e.find((item) => item.label.includes("All"));
      } else {
        schoolOptions = e.label.includes("All");
      }
      if (schoolOptions) {
        setFunID({ value: 0, label: "All" });
        setFID(0);
      } else {
        setFunID(e);
        setFID(111);
      }
    } else {
      setFunID("");
      setFID(0);
    }
  }

  function handleGroup(e) {
    if (e !== null) {
      let schoolOptions = "";
      if (Array.isArray(e)) {
        schoolOptions = e.find((item) => item.label.includes("All"));
      } else {
        schoolOptions = e.label.includes("All");
      }
      if (schoolOptions) {
        setGrpID({ value: 0, label: "All" });
        setGID(0);
      } else {
        setGrpID(e);
        setGID(111);
      }
    } else {
      setGrpID("");
      setGID(0);
    }
  }

  function handleproduct(e) {
    e.preventDefault();
    setErrorMsg("");
    var emsg = "";
    if (venid.length !== 0) {
      if (pdtid !== "") {
        if (pdtname !== "") {
          if (pdtprice !== "") {
            if (ofrprice !== "") {
              if (pimage !== "") {
                if (purl !== "") {
                  if (webid.length !== 0) {
                    const temp = new FormData();
                    temp.append("admin_id", localStorage.getItem("UID"));
                    temp.append("vendor_id", venid.value);
                    temp.append("product_id", pdtid);
                    temp.append("product_name", pdtname);
                    temp.append("product_price", pdtprice);
                    temp.append("offer_price", ofrprice);
                    temp.append("image_url", pimage);
                    temp.append("product_url", purl);
                    if (pid != 0) {
                      temp.append("product_ins_id", pid);
                      if (wsch) {
                        temp.append("school_display", 1);
                      }else{
                        temp.append("school_display", 0);
                      }

                      if (wfun) {
                        temp.append("funder_display", 1);
                      }else{
                        temp.append("funder_display", 0);
                      }

                      if (wgrp) {
                        temp.append("group_display", 1);
                      }else{
                        temp.append("group_display", 0);
                      }
                    temp.append("color", pdtclr);

                      dotracking(
                        "add button in product for vendor - " +
                          venid.label +
                          " ( " +
                          venid.value +
                          " ) , product id - " +
                          pdtid +
                          " , product name - " +
                          pdtname +
                          " ( " +
                          pid +
                          ") , price - " +
                          pdtprice +
                          " , offer price - " +
                          ofrprice +
                          " , image - " +
                          pimage +
                          " , product url - " +
                          purl +
                          " $$ " +
                          trackobj.pdtheading
                      );
                      productupdate(temp).then((res) => {
                        if (res.status === true) {
                          handleclose();
                          listall();
                          toast.success(res.message);
                        }
                      });
                    } else {
                      if (wsch) {
                        temp.append("school_display", 1);
                        if (ssid == 0) {
                          emsg = " all school webpage ";
                          temp.append("school_display_all", 1);
                        } else {
                          emsg = emsg + " school webpage - ";
                          temp.append("school_display_all", 2);
                          temp.append("schools_count", schid.length);
                          for (let i = 0; i < schid.length; i++) {
                            emsg = emsg + schid[i].label + ", ";
                            temp.append(
                              "schools_id_" + [i + 1],
                              schid[i].value
                            );
                          }
                        }
                      } else {
                        temp.append("school_display", 0);
                        temp.append("school_display_all", 0);
                      }

                      if (wfun) {
                        temp.append("funder_display", 1);
                        if (ffid == 0) {
                          emsg = emsg + " all funder webpage ";
                          temp.append("funder_display_all", 1);
                        } else {
                          emsg = emsg + " funder webpage - ";
                          temp.append("funder_display_all", 2);
                          temp.append("funders_count", funid.length);
                          for (let i = 0; i < funid.length; i++) {
                            emsg = emsg + funid[i].label + ", ";
                            temp.append(
                              "funders_id_" + [i + 1],
                              funid[i].value
                            );
                          }
                        }
                      } else {
                        temp.append("funder_display", 0);
                        temp.append("funder_display_all", 0);
                      }

                      if (wgrp) {
                        temp.append("group_display", 1);
                        if (ggid == 0) {
                          emsg = emsg + " all group of school webpage ";
                          temp.append("group_display_all", 1);
                        } else {
                          emsg = emsg + " group of school webpage - ";
                          temp.append("group_display_all", 2);
                          temp.append("groups_count", grpid.length);
                          for (let i = 0; i < grpid.length; i++) {
                            emsg = emsg + grpid[i].label + ", ";
                            temp.append("groups_id_" + [i + 1], grpid[i].value);
                          }
                        }
                      } else {
                        temp.append("group_display", 0);
                        temp.append("group_display_all", 0);
                      }
                      temp.append("color", pdtclr);

                      dotracking(
                        "add button in product for vendor - " +
                          venid.label +
                          " ( " +
                          venid.value +
                          " ) , product id - " +
                          pdtid +
                          " , product name - " +
                          pdtname +
                          " , price - " +
                          pdtprice +
                          " , offer price - " +
                          ofrprice +
                          " , image - " +
                          pimage +
                          " , product url - " +
                          purl +
                          " , " +
                          emsg +
                          " $$ " +
                          trackobj.pdtheading
                      );
                      productcreate(temp).then((res) => {
                        if (res.status === true) {
                          handleclose();
                          listall();
                          toast.success(res.message);
                        }
                      });
                    }
                  } else {
                    setErrorMsg("Please Select Webpages");
                  }
                } else {
                  setErrorMsg("Please Enter Product Url");
                }
              } else {
                setErrorMsg("Please Enter Product Image Url");
              }
            } else {
              setErrorMsg("Please Enter Offer Price");
            }
          } else {
            setErrorMsg("Please Enter Product Price");
          }
        } else {
          setErrorMsg("Please Enter Product Name");
        }
      } else {
        setErrorMsg("Please Enter Product ID");
      }
    } else {
      setErrorMsg("Please Select Vendor");
    }
  }
  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">Products List</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Products</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Products List
          </li>
        </ol>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="text-right">
            <a className="btn btn-success" onClick={handleshow}>
              <i className="fa fa-plus"></i> Add Product{" "}
            </a>
          </div>
          <div className="ag-theme-alpine ag-style mt-2">
            <AgGridReact
              columnDefs={columnDefs}
              rowData={filterProduct}
              pagination="true"
              paginationPageSize="10"
              sortingOrder={["asc", "desc"]}
              suppressExcelExport={true}
              suppressDragLeaveHidesColumns={true}
              domLayout="autoWidth"
              onGridReady={(params) => {
                params.api.sizeColumnsToFit();
              }}
            />
          </div>
        </div>
      </div>

      <Modal show={show} size="xl" onHide={handleclose}>
        <Modal.Header>
          {pid !== 0 && <h4> Product Details</h4>}
          {pid === 0 && <h4> Add Product</h4>}
        </Modal.Header>
        <Modal.Body>
          <Row className="row-sm mx-0">
            <Col lg={6} md={6}>
              <div className="form-group">
                <label className="mb-2">
                  Vendor <span className="errortext"> *</span>
                </label>
                <Select
                  className="dropdown"
                  placeholder="Select Vendor"
                  value={venid}
                  options={vlist}
                  onChange={handleVendor}
                  isSearchable={true}
                  isClearable
                  hidden
                />
              </div>
            </Col>
            <Col lg={6} md={6}>
              <div className="form-group">
                <label className="mb-2">
                  Product ID <span className="errortext"> *</span>
                </label>

                <input
                  type="text"
                  placeholder="Product ID"
                  className="form-control"
                  value={pdtid}
                  onChange={(e) => setPdtID(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={6} md={6}>
              <div className="form-group">
                <label className="mb-2">
                  Product Name <span className="errortext"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Product Name"
                  className="form-control"
                  value={pdtname}
                  onChange={(e) => setPdtName(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={6} md={6}>
              <div className="form-group">
                <label className="mb-2">
                  Product Price <span className="errortext"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Product Price"
                  className="form-control"
                  value={pdtprice}
                  onChange={handlePrice}
                />
              </div>
            </Col>
            <Col lg={6} md={6}>
              <div className="form-group">
                <label className="mb-2">
                  Offer Price <span className="errortext"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Offer Price"
                  className="form-control"
                  value={ofrprice}
                  onChange={handleOffer}
                />
              </div>
            </Col>
            <Col lg={6} md={6}>
              <div className="form-group">
                <label className="mb-2">
                  Image URL <span className="errortext"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Image URL"
                  className="form-control"
                  value={pimage}
                  onChange={(e) => setPImage(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={6} md={6}>
              <div className="form-group">
                <label className="mb-2">
                  Product URL <span className="errortext"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Product URL"
                  className="form-control"
                  value={purl}
                  onChange={(e) => setPUrl(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={6} md={6}>
              <div className="form-group">
                <label className="mb-2">
                  Product Color
                   {/* <span className="errortext"> *</span> */}
                </label>
                <input
                  type="text"
                  placeholder="Product Color"
                  className="form-control"
                  value={pdtclr}
                  onChange={(e) => setPdtClr(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={6} md={6}>
              <div className="form-group">
                <label className="mb-2">
                  Webpages <span className="errortext"> *</span>
                </label>
                <Select
                  className="dropdown"
                  placeholder="Select Webpages"
                  value={webid}
                  options={wlist}
                  onChange={handleWebpage}
                  isSearchable={true}
                  isMulti
                  isClearable
                  hidden
                />
              </div>
            </Col>
            {pid == 0 && (
              <>
                {wsch && (
                  <Col lg={6} md={6}>
                    <div className="form-group">
                      <label className="mb-2">
                        School <span className="errortext"> *</span>
                      </label>
                      <Select
                        className="dropdown"
                        placeholder="Select School"
                        value={schid}
                        options={slist}
                        onChange={handleSchool}
                        isSearchable={true}
                        isMulti={ssid > 0}
                        isClearable
                        hidden
                      />
                    </div>
                  </Col>
                )}
                {wfun && (
                  <Col lg={6} md={6}>
                    <div className="form-group">
                      <label className="mb-2">
                        Funder <span className="errortext"> *</span>
                      </label>
                      <Select
                        className="dropdown"
                        placeholder="Select Funder"
                        value={funid}
                        options={flist}
                        onChange={handleFunder}
                        isSearchable={true}
                        isMulti={ffid > 0}
                        isClearable
                        hidden
                      />
                    </div>
                  </Col>
                )}
                {wgrp && (
                  <Col lg={6} md={6}>
                    <div className="form-group">
                      <label className="mb-2">
                        Group of School <span className="errortext"> *</span>
                      </label>
                      <Select
                        className="dropdown"
                        placeholder="Select Group of School"
                        value={grpid}
                        options={glist}
                        onChange={handleGroup}
                        isSearchable={true}
                        isMulti={ggid > 0}
                        isClearable
                        hidden
                      />
                    </div>
                  </Col>
                )}
              </>
            )}

            {errorMsg !== "" && <span className="errortext">{errorMsg}</span>}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <a className="btn btn-danger" onClick={handleclose}>
            Close
          </a>
          {pid !== 0 && (
            <a className="btn btn-success" onClick={handleproduct}>
              Update
            </a>
          )}
          {pid === 0 && (
            <a className="btn btn-success" onClick={handleproduct}>
              Add
            </a>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};
